// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (max-width:719px){.LukonTermination__optionContent___x55Sc{display:inline!important;display:initial!important}}[data-aos=fade-up]{transform:translateY(50px);opacity:0;transition-property:transform,opacity}[data-aos=fade-up].LukonTermination__aos-animate___2dv8S{transform:none;opacity:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"optionContent": "LukonTermination__optionContent___x55Sc",
	"aos-animate": "LukonTermination__aos-animate___2dv8S"
};
module.exports = ___CSS_LOADER_EXPORT___;
